import { render, staticRenderFns } from "./view-form-draggable.vue?vue&type=template&id=0918a6d0&"
import script from "./view-form-draggable.vue?vue&type=script&lang=js&"
export * from "./view-form-draggable.vue?vue&type=script&lang=js&"
import style0 from "./view-form-draggable.vue?vue&type=style&index=0&id=0918a6d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports